import { useDispatch, useSelector } from 'react-redux';
import { getChildOuData } from 'redux/slices/getChildOu';

export const useRefreshOuTab = () => {
  const dispatch = useDispatch();
  const role = localStorage.getItem('role');
  const selectedNode = useSelector((state) => state.selectedNode);
  const adminOuName = useSelector((state) => state.ouTreeData.data);
  const { pageOuNumber, pageOuSize, ouSearch, ouIsDescending, ouSortType } = useSelector(
    (state) => state.getChildOuData
  );
  let uservalue;

  if (role === 'ouadmin') {
    uservalue = {
      ouName: adminOuName && adminOuName.dnName,
      fqdn: selectedNode.domainName || localStorage.getItem('domain'),
      page: pageOuNumber,
      pageSize: pageOuSize,
      searchQuery: ouSearch,
      isDescending: ouIsDescending,
      sortType: ouSortType,
    };
  } else {
    uservalue = {
      ouName:
        selectedNode.selectedNode && selectedNode.selectedNode.dnName
          ? selectedNode.selectedNode.dnName
          : localStorage.getItem('domainDn'),
      fqdn: selectedNode.domainName || localStorage.getItem('domain'),
      page: pageOuNumber,
      pageSize: pageOuSize,
      searchQuery: ouSearch,
      isDescending: ouIsDescending,
      sortType: ouSortType,
    };
  }

  const refreshOuTab = () => {
    dispatch(getChildOuData(uservalue));
  };

  return refreshOuTab;
};
